import { useNavigate } from 'react-router-dom';
import { RiLockLine } from 'react-icons/ri';

const AccessDenied = () => {
    const navigate = useNavigate();

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            padding: '2rem',
            textAlign: 'center',
            fontFamily: "'Plus Jakarta Sans', sans-serif",
        }}>
            <div style={{
                width: 64,
                height: 64,
                borderRadius: '50%',
                background: '#FEE2E2',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '1.5rem',
            }}>
                <RiLockLine style={{ fontSize: '1.75rem', color: '#DC2626' }} />
            </div>
            <h2 style={{ margin: '0 0 0.5rem', fontSize: '1.25rem', fontWeight: 700, color: '#18181B' }}>
                Dashboard Access Unavailable
            </h2>
            <p style={{ margin: '0 0 2rem', fontSize: '1rem', color: '#71717A', maxWidth: 400, lineHeight: 1.5 }}>
                Dashboard access is not enabled for your account. Please contact the Operations team to request access.
            </p>
            <button
                onClick={() => navigate('/', { replace: true })}
                style={{
                    padding: '0.75rem 1.5rem',
                    fontSize: '0.9375rem',
                    fontWeight: 600,
                    background: '#0F1B2D',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 12,
                    cursor: 'pointer',
                    fontFamily: 'inherit',
                }}
            >
                Go to Scanner App
            </button>
        </div>
    );
};

export default AccessDenied;
